export default __webpack_public_path__ + "23e6b059df4e983a7b855a4417e6c9da.png";